export default __webpack_public_path__ + "static/media/NotesnotesIcon.b1b51428.svg";